import * as Yup from "yup";
import { useState } from 'react';
import { Form, Formik } from "formik";
import { useRecoilValue } from "recoil";
import { toast } from "react-toastify";
import useStyles from "../../../../styles/styles";
import { configState } from "../../../../recoil/atoms";
import { EmployeeApi } from "../../../../api/clinic-management";
import { Button, Divider, Grid, Typography } from "@mui/material";
import AutocompleteBranch from "../FormFields/AutocompleteBranch";

type props = {  
  userID: string;
  handleCloseModal: Function;  
};

const GrantAccessModel = ({ handleCloseModal, userID }: props) => {
  const classes = useStyles();
  const config = useRecoilValue(configState);

  const [selectedBranchID, setSelectedBranchID] = useState<string>("");

  const AddEmployeeToBranch = () => {
    const access = new EmployeeApi(config);
    access
      .employeeBranchAccess(userID, selectedBranchID)
      .then((res) => {
        toast.success(res?.data?.Message!);
        handleCloseModal();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const handleSubmit = () => {
    AddEmployeeToBranch();
  };

  return (
    <>
      <Formik
        initialValues={{
          BranchID: '',
        }}
        enableReinitialize={true}
        validationSchema={Yup.object().shape({
          BranchID: Yup.string().trim().required("Required"),
        })}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
              Add Employee To Branch
            </Typography>
            <Divider />
            <Grid
              container
              rowSpacing={4}
              spacing={2}
              sx={{
                pt: 4,
                mt: 2,
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <Grid item xs={12} sm={10}>
              <AutocompleteBranch
                name="BranchID"
                setSelectedBranchID={setSelectedBranchID}
              />
              </Grid>
              <Grid container />
              <Grid container />
            </Grid>
            <Grid container className={classes.buttons} sx={{ mt: 6 }}>
              <Grid item className={classes.wrapper}>
                <Button onClick={() => handleCloseModal()} variant="contained" color="error" className={classes.button}>
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="secondary" className={classes.button}>
                  Add
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default GrantAccessModel;
